import React from "react";
import { useParams } from "react-router-dom";

import { ItemPreview, useQueryGetItem } from "@examspark/common-app";
import { VSpace } from "@examspark/common-ui";

import Breadcrumbs from "../../components/common/Breadcrumbs";
import PageHead from "../../components/common/PageHead";
import PageTitle from "../../components/common/PageTitle";
import ResourceTools from "../../components/resources/ResourceTools";

const ItemRoute = () => {
  const params = useParams<{
    id: string;
  }>();
  const { data } = useQueryGetItem(params.id, "item#v0");

  if (!params.id) return null;

  return (
    <VSpace size="3rem">
      <PageHead>
        <Breadcrumbs items={Breadcrumbs.Dashboard()} />
        <PageTitle
          subtitle="Assessment Item"
          tools={<ResourceTools resource={data} />}
        >
          {data?.name}
        </PageTitle>
      </PageHead>
      <ItemPreview itemId={params.id} />
    </VSpace>
  );
};

export default ItemRoute;
